
import { defineComponent, ref, onMounted, computed } from 'vue'
import { useStore } from 'vuex'
import { debounce, remove } from 'lodash-es';

interface Form {
  org_id: string;
  vendor_id: string;
  start_date: Date;
  end_date: Date;
}

export default defineComponent({
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: 'Form',
        },
        data: {
            type: Object,
        },
        loading: {
            type: Boolean,
            default: false,
        }
    },
    setup (props, { emit }) {
        const form = ref<any>(props.data);

        const name = ref(props.title)
        const store = useStore()
        const selectedOrgId = ref(null)
        const disabled_vendor = ref(false)
        
        onMounted(() => {
            store.dispatch('Option/getAllSites').then(() => {
                // Set the value of v-model to the org_id of the first site
                form.value.org_id = sites.value[0].org_id;
                handleSiteChange(form.value.org_id)
            });
            form.value.vendor_id = 'all';
        })

        const sites =  computed(() => store.getters['Option/all_sites'])

        const filterOption = (
            input: string,
            option: { children: { children: string }[] }
            ) => {
            return (
                option.children[0].children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            );
        };

        var vendors: { value: string; label: string; disabled: boolean; vendor_id: string; org_id: string; }[] = [];
        const vendor_fetching = ref(false);

        const handleSiteChange = (payload: any) => {
            selectedOrgId.value = payload 
            form.value.vendor_id = 'all'
            fetchVendors(null)
        }

        const handleSearchVendor = debounce(value => {
            vendor_fetching.value = false;
            fetchVendors(value)
        }, 500);

        const fetchVendors = (value:any) => {
            vendors.length = 0
            vendor_fetching.value = true;
            const payload = {search:value, org_id: form.value.org_id };
            store.dispatch('Option/getAllVendorPerOrg', payload).then((res) => {
                
                res.forEach((element:any) => {
                    vendors.push({
                        value: element.id,
                        label: element.org_code ? element.vendor_name + '('+ element.org_code +')' : element.vendor_name ,
                        disabled: false,
                        vendor_id: element.vendor_id,
                        org_id: element.org_id,
                    });
                });
                vendor_fetching.value = false;
            })
        };
        
        const cancelDownload = () => {
            resetForm()
            emit('cancel');
        }

        const resetForm = () => {
            handleSiteChange(form.value.org_id)
            form.value.vendor_id = 'all'
            form.value.start_date = null
            form.value.end_date = null
        }


        return {
            form,
            sites,
            name,
            filterOption,
            handleSiteChange,
            handleSearchVendor,
            vendors,
            vendor_fetching,
            disabled_vendor,
            cancelDownload,
            resetForm
        }
    },
})
